import { lazy } from 'react'

const Account = lazy(() => import('../../views/pages/account'))
const ResetEmail = lazy(() => import('../../views/pages/account/change-email/reset'))
const ResetPhone = lazy(() => import('../../views/pages/account/change-phone/reset'))
const ResetSecPassword = lazy(() => import('../../views/pages/account/change-secpassword/reset'))
const UpdateInfo = lazy(() => import('../../views/pages/auth/update-info/'))

const routes = [
	{
		path: '/account',
		element: <Account />,
		meta: {
			publicRoute: false
		}
	},
	{
		path: '/verify-resetemail/:token',
		element: <ResetEmail />,
		meta: {
			layout: 'blank',
			publicRoute: true
		}
	},
	{
		path: '/verify-resetphone/:token',
		element: <ResetPhone />,
		meta: {
			layout: 'blank',
			publicRoute: true
		}
	},
	{
		path: '/verify-resetsecpassword/:token',
		element: <ResetSecPassword />,
		meta: {
			layout: 'blank',
			publicRoute: true
		}
	},
	{
		path: '/verify-accountinfo/:token',
		element: <UpdateInfo />,
		meta: {
			layout: 'blank',
			publicRoute: true
		}
	}
]

export default routes
